import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import Raven from 'raven-js';
import reducer from './reducers';
import { StateContainer } from './containers';
import { fetchClientSettings } from './actions';
import { chatMiddleware } from './services/chat';
import chatHistoryMiddlewareThunk, { rebuildMessagesFromHistory } from './services/history';
import isInPrivateMode from './services/private';
import { messageListener } from './services/global';
import { storage } from './services/storage';

// Set up Raven
process.env.SENTRY_DSN && Raven.config(process.env.SENTRY_DSN).install();

// Create store
const store = createStore(
	reducer,
	applyMiddleware(thunk, chatHistoryMiddlewareThunk.withExtraArgument(store), chatMiddleware)
)

// Make request to API for client info
store.dispatch(fetchClientSettings(store));

// Rebuild messages from local storage
if (!isInPrivateMode()) {
	rebuildMessagesFromHistory(store);
}

// Listen to "message" window events
messageListener(store);

render(
	<Provider store={store} >
		<StateContainer />
	</Provider>,
	document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/app.js